var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classObj,
    style: ({
      width: _vm.width
    })
  }, [_c('div', {
    class: (_vm.prefixCls + "-input-number-handler-wrap")
  }, [_c('a', {
    ref: "up",
    class: [_vm.prefixCls + '-input-number-handler', _vm.prefixCls + '-input-number-handler-up', _vm.upDisabledClass],
    attrs: {
      "unselectable": "unselectable"
    },
    on: {
      "click": _vm._up,
      "mouse": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.preventDefault($event)
      }
    }
  }, [_c('n3-icon', {
    class: (_vm.prefixCls + "-input-number-handler-up-inner"),
    attrs: {
      "type": "angle-up",
      "unselectable": "unselectable"
    },
    on: {
      "click": _vm.preventDefault
    }
  })], 1), _vm._v(" "), _c('a', {
    ref: "down",
    class: [_vm.prefixCls + '-input-number-handler', _vm.prefixCls + '-input-number-handler-down', _vm.downDisabledClass],
    attrs: {
      "unselectable": "unselectable"
    },
    on: {
      "mouse": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.preventDefault($event)
      },
      "click": _vm._down
    }
  }, [_c('n3-icon', {
    class: (_vm.prefixCls + "-input-number-handler-down-inner"),
    attrs: {
      "type": "angle-down",
      "unselectable": "unselectable"
    },
    on: {
      "click": _vm.preventDefault
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: _vm.prefixCls + '-input-number-input-wrap'
  }, [_c('n3-input', {
    attrs: {
      "type": "number",
      "width": _vm.width,
      "rules": _vm.rules,
      "placeholder": _vm.placeholder,
      "custom-validate": _vm.customValidate,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "name": _vm.name,
      "value": _vm.currentValue
    },
    on: {
      "focus": _vm._onFocus,
      "blur": _vm._onBlur,
      "change": _vm._onChange
    },
    nativeOn: {
      "keydown": function($event) {
        $event.stopPropagation();
        _vm._onKeyDown($event)
      }
    }
  })], 1)])
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2b6385d8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b6385d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/InputNumber/n3InputNumber.vue
// module id = 610
// module chunks = 0 1